import classNames from "classnames";
import KinoklubbTicket from "@/components/KinoklubbTicket";
import TicketButton from "@/components/TicketButton";
import { isSameDay } from "date-fns";
import type { IShowsForMovie, ITheatreProgram } from "@/lib/types/Program";
import type Show from "@/lib/types/Show";
import { useMemo } from "react";
import styles from "./Shows.module.css";



//#region [Props]
type ShowsProps = {
    data?: IShowsForMovie | ITheatreProgram;
    isKinoklubb?: boolean;
};
//#endregion

type ExpandedShow = {
    dateGroup: string;
} & Show;


//#region [Component]
export default function Shows({ data, isKinoklubb = false }: ShowsProps) {

    const shows = useMemo(() => {
        let prevDate: Date | null;
        let flag: boolean = false;
        if ((data?.shows?.length ?? 0) === 0) {
            return null;
        }
        return data?.shows?.map(show => {
            const s = show as ExpandedShow;

            if (prevDate === null) {
                prevDate = s.showStartDate;
            } else if (!isSameDay(prevDate, s.showStartDate)) {
                flag = !flag;
            }
            prevDate = s.showStartDate;
            s.dateGroup = flag ? styles.even : styles.odd;
            return s;
        });
    }, [data]);


    if (!shows) {
        return null;
    }

    return <div className={styles.SShowsContainer}>
        {isKinoklubb && <KinoklubbTicket className={styles.SKinoklubbTicket} />}
        {shows.map(show => <TicketButton className={classNames(styles.STicketButton, show.dateGroup)} key={show.ticketSaleUrl.toString()} show={show} showDate showPassed appendShowType />)}
    </div>

}
//#endregion